import { Component, Input } from '@angular/core';

import { ReadonlyImageComponent } from '../readonly-image/readonly-image.component';

@Component({
  selector: 'stx-image-thumbnail',
  templateUrl: './image-thumbnail.component.html',
  styleUrls: ['./image-thumbnail.component.scss'],
  imports: [ReadonlyImageComponent]
})
export class ImageThumbnailComponent {
  @Input() imageUrl: string;
  @Input() imageAlt: string;
  @Input() thumbnailId: string;
  @Input() mediaId: number;
  @Input() mediaAnonymized = false;
}
